import { render, staticRenderFns } from "./ConfirmRegionPopup.vue?vue&type=template&id=64126d28&scoped=true&"
import script from "./ConfirmRegionPopup.vue?vue&type=script&lang=js&"
export * from "./ConfirmRegionPopup.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRegionPopup.vue?vue&type=style&index=0&id=64126d28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64126d28",
  null
  
)

export default component.exports